<template>
  <div>
    <div
      v-for="item in renderComponentList"
      :id="item.preId ? `${item.preId}-${item.moduleId}` : ''"
      :key="item.key"
      :class="['component-wrapper', {'special-wraper': item.componentType == '67' || item.componentType == '68'}]"
    >
      <component
        :is="getComponent(item.componentName)"
        v-sa-track="[{type: 'visually', event: 'component_show', data: getTrackData(item)}]"
        :locale="locale"
        :module-id="item.moduleId"
        :component-name="item.componentName"
        :component-type="item.componentType"
        :component-title="item.componentTitle"
        :registration="item.registration"
        v-bind="item.componentData"
        @hook:mounted="onChildMounted"
      />
    </div>
  </div>
</template>

<script>
import mixin from './mixin'
// 组件映射表
const componentMap = {
  // banner1
  Banner: () => import(/* webpackPrefetch: true */ './Banner/web'),
  // banner2
  Banner2: () => import(/* webpackPrefetch: true */ './Banner-2/web'),
  // 通用图片组件3
  Banner3: () => import(/* webpackPrefetch: true */ './Banner-3/web'),
  // 分类组件
  Category: () => import('./Category/web'),
  // 模拟考组件
  MockExamColumn: () => import('./MockExamColumn/web'),
  // 图文组件（一）文本样式1
  ModuleRichText: () => import('./ModuleRichText/web'),
  // 图文组件（二）文本样式2
  PageRichText: () => import('./PageRichText/web'),
  // 留资组件1
  GetNotified: () => import('./GetNotified/web'),
  // 留资组件2 留资组件
  GetNotified2: () => import('./GetNotified-2/web'),
  // 报名组件
  Application: () => import('./Application/web'),
  // 图文组件：轮播组件
  CarouselComponent: () => import('./CarouselComponent/web'),
  // 吸底组件
  suctionBottom: () => import('./SuctionBottom/web'),
  // 课程组件：课程列表组件
  CourseListComponent: () => import('./CourseListComponent/web'),
  // 资讯组件
  NewsGroup: () => import('./NewsGroup/web'),
  // 评价组件 自定义
  UserComments: () => import('./UserComments/web'),
  // Ad-1
  Ad1: () => import('./Ad-1/web'),
  // Ad-2
  Ad2: () => import('./Ad-2/web'),
  // Ad-3
  Ad3: () => import('./Ad-3/web'),
  // Ad-4
  Ad4: () => import('./Ad-4/web'),
  // Ad-5
  Ad5: () => import('./Ad-5/web'),
  // Ad-6
  Ad6: () => import('./Ad-6/web'),
  // Ad-7
  Ad7: () => import('./Ad-7/web'),
  // Ad-8
  Ad8: () => import('./Ad-8/web'),
  // Ad-9
  Ad9: () => import('./Ad-9/web'),
  // 自定义表单组件
  CustomerForm: () => import('./CustomerForm/web'),
  // 自定义按钮组件
  CustomButton: () => import('./CustomButton/web'),
  // 通用图片组件
  ImageList: () => import('./ImageList/web'),
  // 带标题通用图片组件（通用图片组件2)
  generalImgTwo: () => import('./generalImgTwo/web'),
  // 大图评价组件
  UserCommentsBigPicture: () => import('./UserCommentsBigPicture/web'),
  // FAQ文本样式组件
  Faqs: () => import('./Faqs/web'),
  // 富文本分栏组件 左右二分栏文本样式组件
  RichTextColumn: () => import('./RichTextColumn/web'),
  // 资料组件
  resourcesColumn: () => import('./Resource/web'),
  // 班级栏目组件
  ClassColumn: () => import('./ClassColumn/web'),
  // 课程栏目(一)组件
  CoursesColumn1: () => import('./CoursesColumn-1/web'),
  // 课程栏目(二)组件
  CoursesColumn2: () => import('./CoursesColumn-2/web'),
  // 课程详情栏目组件
  CoursesDetailColumn: () => import('./CoursesDetailColumn/web'),
  // 录播课组件
  RecordedGoodsColumn: () => import('./RecordedGoodsColumn/web'),
  // 通用商品组件
  CommonGoodsColumn: () => import('./CommonGoodsColumn/web'),
  // 数字滚动组件
  NumberScroll: () => import('./NumberScroll/web'),
  // 诊断入口组件
  EvaluationEntry: () => import('./EvaluationEntry/web'),
  // 图文组件：地图组件
  Map: () => import('./Map/web'),
  // 动态组件
  Dynamic: () => import('./Dynamic/web'),
  // Trustpilot评分组件
  Trustpilot: () => import('./Trustpilot/web'),
  // tmc 查分组件
  ScoreQueryComponent: () => import('./ScoreQueryComponent/web'),
  // 营销位组件
  MarketComponents: () => import('./MarketComponents/web'),
  // 主banner组件
  MainBanner: () => import(/* webpackPrefetch: true */ './MainBanner/web'),
  // 合作商家组件
  Partners: () => import(/* webpackPrefetch: true */ './Partners/web'),
}

export default {
  name: 'DynamicComponent',
  mixins: [mixin],
  methods: {
    getComponent(componentName) {
      return componentMap[componentName] || null;
    },
  },

}
</script>

<style lang="scss" scoped>
.component-wrapper {
  margin-bottom: 60px;

  &:last-child {
    margin-top: 0;
  }

  &.special-wraper {
    margin-bottom: 0;
  }
}
</style>
